import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography } from '@material-ui/core';
import TypographyHeaderSub from './TypographyHeaderSub';
import useMobile from 'utils/useMobile';
const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  mb16: {
    marginBottom: 16
  },
  content: {
    maxWidth: 671,
    padding: 48,
    marginTop: 32,
    marginBottom: 32
  }
}));

const SectionAbout = () => {
  const classes = useStyles({})
;
  const isMobile = useMobile();

  return (
    <div id="about" className={classes.root}>
      <div className={classes.content}>
        <TypographyHeaderSub className={classes.mb16}>ABOUT</TypographyHeaderSub>
        <Typography className={classes.mb16} variant={isMobile ? 'h4' : 'h2'}>
          THE PROGRAM
        </Typography>
        <Typography variant="body1">
          BodyF1RST Core 4 Wellness Program is a complete lifestyle program. It is your answer to achieving your health
          and fitness goals. This functional resistance strength training program focuses on 4 core principles of Total
          Optimization - Spirit, Mindset, Nutrition, Exercise. BodyF1RST’s comprehensive training program is your guide
          to achieve Total Optimization. Your monthly subscription of only $20 gives you full access to all the
          components of living the BodyF1RST Lifestyle (over 30 training videos each month, the Getting Started Goal
          Setting Guide, Spirit Princple Guide, Mindset Princple Guide, Nutrition Princple Guide with sample meal plan,
          and the Exercise Princple Guide plus assessment information.) Plus fitness and nutritional tips, recommended
          supplements and much more... It’s time to put your BodyF1RST!
        </Typography>
      </div>
    </div>
  );
};

export default SectionAbout;
